import { useEffect, useState } from 'react';
import { isSmartPhone } from '../../utilities/helper';
import MatchMakingLoaderMWeb from './index_mWeb';
import MatchMakingLoaderWeb from './index_web';

const MatchMakingLoader = ({ onCancel, onPressTryAgain, isLandscape }: any) => {
  const initialTimer = 20;
  const [timer, setTimer] = useState(initialTimer);
  const [isPlayerNotFound, setIsPlayerNotFound] = useState(false);

  const onPressTryAgain_ = () => {
    setIsPlayerNotFound(false);
    setTimer(initialTimer);
    onPressTryAgain();
  };

  useEffect(() => {
    const setTimerInterval = setInterval(() => {
      if (timer !== 0) {
        setTimer(timer - 1);
      }
    }, 1000);
    return () => {
      clearInterval(setTimerInterval);
    };
  });

  if (isSmartPhone && !isLandscape) {
    return (
      <MatchMakingLoaderMWeb
        onCancel={onCancel}
        onPressTryAgain_={onPressTryAgain_}
        timer={timer}
        isPlayerNotFound={isPlayerNotFound}
      />
    );
  }

  return (
    <MatchMakingLoaderWeb
      onCancel={onCancel}
      isLandscape={isLandscape}
      onPressTryAgain_={onPressTryAgain_}
      timer={timer}
      isPlayerNotFound={isPlayerNotFound}
    />
  );
};

export default MatchMakingLoader;
